import React, { HTMLAttributes } from "react";
import BudgetForm from "src/components/forms/TaskForm/steps/budget/BudgetForm";
import Descriptionform from "src/components/forms/TaskForm/steps/DescriptionForm";
import AddressForm from "src/components/forms/TaskForm/steps/AddressForm";
import TargetForm from "src/components/forms/TaskForm/steps/TargetForm";
import StudentPoolForm from "src/components/forms/TaskForm/steps/StudentPoolForm";
import SummaryForm from "src/components/forms/TaskForm/steps/SummaryForm";
import InterviewForm from "src/components/forms/TaskForm/steps/InterviewForm";
import DeleteForm from "src/components/forms/TaskForm/steps/DeleteForm";
import SubtasksForm from "src/components/forms/TaskForm/steps/SubtasksForm";
import AIQuestionsForm from "src/components/forms/TaskForm/steps/AIQuestionsForm";
import ExtraForm from "src/components/forms/TaskForm/steps/ExtraForm";
import VisibilityForm from "src/components/forms/TaskForm/steps/VisibilityForm";
import SummaryAIForm from "src/components/forms/TaskForm/steps/SummaryAIForm";

interface TaskFormProps extends HTMLAttributes<HTMLFormElement> {}

export interface TaskFormOptions {
	hideButtons?: boolean;
}

const TaskForm = ({ children, ...rest }: TaskFormProps) => {
	return <form {...rest}>{children}</form>;
};

TaskForm.Budget = BudgetForm;
TaskForm.Description = Descriptionform;
TaskForm.Address = AddressForm;
TaskForm.Target = TargetForm;
TaskForm.StudentPool = StudentPoolForm;
TaskForm.Summary = SummaryForm;
TaskForm.Interview = InterviewForm;
TaskForm.Delete = DeleteForm;
TaskForm.Subtasks = SubtasksForm;
TaskForm.AIQuestions = AIQuestionsForm;
TaskForm.Extra = ExtraForm;
TaskForm.Visibility = VisibilityForm;
TaskForm.SummaryAI = SummaryAIForm;

export default TaskForm;
